// extracted by mini-css-extract-plugin
export default {"flatButton":"flat-button_flatButton__hkOYv","disabled":"flat-button_disabled__1sssH"};